import { parse, stringify } from "flatted";
import { getLocalStorage } from './createPrefixedLocalStorage';
const authenticationsKey = "authentications";
export const userInfoLocalStorageKey = "user-info";
export const addAuthentication = (authenticationKey: string, authenticationValue: string) => {
    const authentications = getAuthentications()
    authentications.add(authenticationKey)

    const prefixedStorage = getLocalStorage()
    prefixedStorage.setItem(authenticationKey, authenticationValue)
    setAuthentications(authentications);
}

export const removeAuthentication = (
    authenticationKey: string,
) => {
    const authentications = getAuthentications();
    authentications.delete(authenticationKey)

    const prefixedStorage = getLocalStorage();
    prefixedStorage.removeItem(authenticationKey);
    setAuthentications(authentications);
};

export const initializeAuthentications = () => {

    const prefixedStorage = getLocalStorage()

    const authentications = prefixedStorage.getItem(authenticationsKey)
    const userInfo = prefixedStorage.getItem(userInfoLocalStorageKey)
    if (userInfo === null && authentications !== null) {
        return
    }

    if (authentications !== null) return

    const authenticationToken = prefixedStorage.getItem("token")
    const authenticationValue = authenticationToken ? stringify(["token"]) : stringify([])
    prefixedStorage.setItem(authenticationsKey, authenticationValue);
    return authenticationValue
}


export const getAuthentications = (): Set<string> => {

    const prefixedStorage = getLocalStorage()

    const authenticationKey = prefixedStorage.getItem(authenticationsKey)
    if (authenticationKey === null) {
        initializeAuthentications()
        const newAuthKey = prefixedStorage.getItem(authenticationsKey) as string
        return new Set(parse(newAuthKey))
    }
    return new Set(parse(authenticationKey))
}

export const setAuthentications = (authentications: Set<string>) => {
    const prefixedStorage = getLocalStorage()
    prefixedStorage.setItem(authenticationsKey, stringify(Array.from(authentications)))
}
